export default [
    {
        path: 'relatorio-historico-permissao-lotacao',
        component: () => import(
            /* webpackChunkName: 'administracao-relatorio-historico-permissao-lotacao' */
            '@/views/administracao/relatorio-historico-permissao-lotacao/Index'
        ),
        redirect: 'relatorio-historico-permissao-lotacao/index',
        children: [
            {
                name: 'administracao-relatorio-historico-permissao-lotacao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'administracao-relatorio-historico-permissao-lotacao' */
                    '@/views/administracao/relatorio-historico-permissao-lotacao/List'
                ),
            },
        ]
    }
]